<template>
    <figure
        class="h-full w-16 text-center p-3 text-white relative"
        :class="status === 'Avslutad' ? 'bg-mimer-red' : 'bg-mimer-purple'">
        <i
            v-if="
                status === 'Resurs tilldelad' || status === 'Påbörjad' || status === 'Pågående' || status === 'Utförd'
            "
            class="material-icons m-auto left-0 top-0 w-full mt-2 text-3xl"
            >build</i
        >
        <i v-if="status === 'Väntar på handläggning'" class="material-icons m-auto left-0 top-0 w-full mt-2 text-3xl"
            >hourglass_empty</i
        >
        <i v-if="status === 'Väntar på beställda varor'" class="material-icons m-auto left-0 top-0 w-full mt-2 text-3xl"
            >local_shipping</i
        >
        <i v-if="status === 'Avslutad'" class="material-icons m-auto left-0 top-0 w-full mt-2 text-3xl">check</i>
    </figure>
</template>

<script>
export default {
    props: ['status'],
};
</script>
